/**
 * Survey API types matching MVP SurveyApiService.js structure
 */

export interface OnRegistrationSurveyRequest {
  reason_for_signup: string[];
  other_signup_reason_text: string | null;
  reason_for_signup_freeform: string;
  user_self_identified_as: string | null;
  other_user_self_identified_as_text: string | null;
}

export interface OnRegistrationSurveyResponse {
  success: boolean;
  message?: string;
}

export class SurveyValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SurveyValidationError";
  }
}
